<template>
    <div class="v-schedule__panel">
        <template v-if="disabled">
            <div class="v-schedule__hints">
                <span class="v-schedule__hint v-schedule__hint_available">
                    Свободное время
                </span>
            </div>
            <div class="v-schedule__controls">
                <button class="v-schedule__control r-button button" @click="setDisabled(false)">
                    Изменить расписание
                </button>
            </div>
        </template>
        <template v-else>
            <div class="v-schedule__hints">
                    <span class="v-schedule__hint v-schedule__hint_available">
                        Доступное время
                    </span>
                <span class="v-schedule__hint v-schedule__hint_selected">
                        Выбранное время
                    </span>
            </div>
            <div class="v-schedule__controls">
                <div class="v-schedule__control">
                    <label class="toggle">
                        <input class="toggle__input screen-reader" type="checkbox"  v-model="isChecked" @change="chooseAllCells($event.target.checked)">
                        <span class="toggle__label" dusk="select-all-time">
                            <span class="toggle__text">Выбрать все время</span>
                        </span>
                    </label>
                </div>
                <button class="v-schedule__control r-button button" @click="saveSchedule()">Сохранить</button>
            </div>
        </template>
    </div>
</template>

<script>
	import {mapState, mapMutations, mapActions} from 'vuex';

    export default {
		name: 'SchedulePanel',
        data() {
            return {
                isChecked: true,
            }
        },
        computed: {
			...mapState([
				'disabled',
                'selectAllButton'
			]),
        },
        methods: {
			...mapMutations([
				'setDisabled',
				'chooseAllCells',
			]),
			...mapActions([
				'saveSchedule',
			]),
        },
        watch: {
            selectAllButton: {
                handler: function (value) {
                    this.isChecked = value;
                },
                immediate: true
            }
        }
    }
</script>

